import styled from "@emotion/styled/macro";

export const ContentLayout = styled.div`
  padding: 0 2em;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 90%;
    max-width: 1024px;
    margin: 0 auto;
    padding: 0 ;
  }
`;


export const BodyContentLayout = styled.div`
  padding: 0 2em;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 76%;
    max-width: 1024px;
    margin: 0 auto;
    padding: 0 ;
  }
`;

